export const signatureForCompare = (values) => {
  if (!values || typeof values !== 'object') return '';
  try {
    const sorted = Object.keys(values)
      .sort()
      .reduce((acc, key) => {
        acc[key] = values[key];
        return acc;
      }, {});
    return JSON.stringify(sorted);
  } catch (_err) {
    return '';
  }
};

export const hasDraftContent = (values) => {
  if (!values || typeof values !== 'object') return false;
  return Object.values(values).some((value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string' && value.trim() === '') return false;
    return true;
  });
};
